window.open_window = function(url) {
    if(window.android) {
        window.android.jnRequestOpenBrowser(url);
    } else if(typeof window.webkit != 'undefined') {
        var sendData = {
            platform: 'ios',
            action: 'openBrowser',
            param: { url: url }
        }
        window.webkit.messageHandlers.iosHandler.postMessage(sendData);
    } else {
        window.open(url, '_blank');
    }
};

window.jnRequestVerify = function () {
    if (window.android) {
        window.android.jnRequestVerify();
    }
};

window.njRegisterGCM = function (gcm) {
    ajaxCall('/app/android/register_gcm', $.param(JSON.parse(gcm)), function(json) {});
};

window.njRegisterDevice = function (gcm) {
    ajaxCall('/app/android/register_device', $.param(JSON.parse(gcm)), function(json) {});
};

window.njUnregisterGCM = function (gcm) {
    ajaxCall('/app/android/unregister_gcm', $.param(JSON.parse(gcm)), function(json) {});
};

/* 원스토어 결제 시작 */
// onestore billing progress 1 결제정보 세팅
window.get_onestore_payload = function (product_id) {
    ajaxCall('/app/android/get_onestore_payload', 'product_id=' + product_id, function(json) {
        if (json.resultType === 'OK' || json.resultType === 'success') {
            jnRequestOnestoreInappBillingPurchase(json.result.ticketId + ":" + json.result.productId);
        }
    });
};

// onestore billing progress 2 앱에 결제요청
window.jnRequestOnestoreInappBillingPurchase = function (payload) {
    if (window.android) {
        window.android.jnRequestOnestoreInappBillingPurchase(payload);
    }
};

// onestore billing progress 3 앱에서 결제완료된 정보 받기
window.njResponseOnestoreInappBillingPurchase = function (paymentData) {
    openModalPaymentProcessing();
    ajaxCall('/app/android/onestore_payment', "paymentData=" + paymentData + '&' + $.param(JSON.parse(paymentData)), function(json) {
        if (json.resultType === 'OK' || json.resultType === 'success') {
            jnRequestOnestoreInappBillingConsume(json.result.developerPayload);
        } else {
            jnRequestOnestoreInappBillingConsume(json.result.developerPayload);
        }
    });
}

// onestore billing progress 4 결제완료된 정보 확인후 앱에 최종 소비 요청
window.jnRequestOnestoreInappBillingConsume = function (developerPayload) {
    if (window.android) {
        window.android.jnRequestOnestoreInappBillingConsume(developerPayload);
    }
};

// onestore billing progress 5 앱에서 소비처리후 마지막 검증 및 결제완료
window.njResponseOnestoreInappBillingConsume = function (paymentData) {
    ajaxCall('/app/android/onestore_consume', "paymentData=" + paymentData + '&' + $.param(JSON.parse(paymentData)), function(json) {
        resultOnestoreInappBillingConsume(json);
    });
};

// 소비처리중 문제가 생겨서 소비처리를 못한 경우
window.jnRequestConsume = function () {
    if (window.android) {
        //toastInfo("이전 인앱결제 있는지 체크");
        window.android.jnRequestConsume();
    }
};
/* 원스토어 결제 끝 */

/* 구글 결제 시작 */
window.get_payload = function (id) {
    ajaxCall('/app/android/get_payload', 'id=' + id, function(json) {
        if (json.resultType === 'OK' || json.resultType === 'success') {
            jnRequestGoogleInappBillingPurchase(JSON.stringify(json.result));
        }
    });
};

// request
window.jnRequestGoogleInappBillingPurchase = function (payload) {
    // 'billing progress 2'
    if (window.android) {
        window.android.jnRequestGoogleInappBillingPurchase(payload);
    }
};

// response
window.njResponseGoogleInappBillingPurchase = function (paymentData) {
    openModalPaymentProcessing();
    ajaxCall('/app/android/payment', $.param(JSON.parse(paymentData)), function(json) {
        if (json.resultType === 'OK' || json.resultType === 'success') {
            jnRequestGoogleInappBillingConsume(json.result.developerPayload);
        } else {
            jnRequestGoogleInappBillingConsume(json.result.developerPayload);
        }
    });
};

window.jnRequestGoogleInappBillingConsume = function (developerPayload) {
    if (window.android) {
        window.android.jnRequestGoogleInappBillingConsume(developerPayload);
    }
};

window.njResponseGoogleInappBillingConsume = function (purchaseJson, signature) {
    ajaxCall('/app/android/consume', 'purchaseJson=' + encodeURIComponent(purchaseJson) + '&signature=' + encodeURIComponent(signature), function(json) {
        resultGoogleInappBillingConsume(json);
    });
};
/* 구글 결제 끝 */

window.jnRequestSetBadge = function (count) {
    if (window.android) {
        window.android.jnRequestSetBadge(count.toString());
    }
};
window.njVerifyBillingServerSide = function () {
    // TODO: 'verifying billing 4'
};

window.gcm_result = function (json) {};
window.njDeliverWeb = function (data) {};
window.njViewResumed = function () {};
window.njResponseVerify = function () {};
window.jnDispatchEvent = function(event, params) {
    if (window.android) {
        window.android.jnDispatchEvent(event, params)
    }
};

// 구글로그인 버튼
window.jnRequestLoginGoogle = function () {
    if (window.android) {
        window.android.jnRequestLoginGoogle();
    }
};

// 구글로그인 콜백
window.njResponseLoginGoogle = function(idToken, authCode) {
    redirect('/auth/google_callback?token=' + encodeURIComponent(idToken) + '&code=' + encodeURIComponent(authCode));
};

// 카카오 로그인 버튼
window.jnRequestLoginKakao = function () {
    if (window.android) {
        window.android.jnRequestLoginKakao();
    }
};

// 카카오 로그인 콜백
window.njResponseLoginKakao = function(accessToken, refreshToken) {
    redirect('/auth/kakaotalk_callback?access_token=' + encodeURIComponent(accessToken) + '&refresh_token=' + encodeURIComponent(refreshToken));
};

// 페이스북 로그인 버튼
window.jnRequestLoginFacebook = function () {
    if (window.android) {
        window.android.jnRequestLoginFacebook()();
    }
};

// 페이스북 로그인 콜백
window.njResponseLoginFacebook = function(token) {
    redirect('/auth/facebook_callback?token=' + encodeURIComponent(token));
};

// ios verify 처리
window.verifyIOS = function() {
    var sendData = {
        platform: 'ios',
        action: 'verify',
        param: {}
    };
    window.webkit.messageHandlers.iosHandler.postMessage(sendData);
}

// ios 콜백 받는 함수
window.calledByNativeIOS = function(json_string) {

    let json = JSON.parse(json_string);
    var platform = json['platform'];
    var action = json['action'];
    var param = json['param'];

    //alert(action);

    if (typeof action == "string") {

        switch (action) {

            // GCM 등록
            case "registerGCM":
                njRegisterGCM(JSON.stringify(json.param));
                break;

            // 상품 구매 요청
            case "purchased":
                var sendData = {
                    platform: 'ios',
                    action: 'consumed',
                    param: {
                        items: []
                    }
                };

                var product_id = '';
                var transaction_id = '';

                let receipt = param['receipt'];
                if (!receipt) {
                    toastError('결제정보가 올바르지 않습니다. invalid receipt! ' + receipt);
                    //verifyIOS();
                    return;
                }

                let in_app = receipt['in_app'];
                if (!in_app || !Array.isArray(in_app)) {
                    toastError('결제정보가 올바르지 않습니다. invalid in_app! ' + in_app);
                    //verifyIOS();
                    return;
                }
                for (let el of in_app) {
                    //alert(JSON.stringify(el));
                    sendData.param.items.push({
                        productId: el['product_id'],
                        transactionId: el['transaction_id']
                    });

                    product_id = el['product_id'];
                    transaction_id = el['transaction_id'];
                }

                //alert(JSON.stringify(sendData));
                openModalPaymentProcessing();
                ajaxCall('/app/apple/consume', 'product_id=' + encodeURIComponent(product_id) + '&transaction_id=' + encodeURIComponent(transaction_id), function(json) {
                    if (json.resultType !== 'success') {
                        return;
                    }
                    window.webkit.messageHandlers.iosHandler.postMessage(sendData);
                });

                break;
        }

    }

    // 디버그용
    // ajaxCall('/app/debug', 'data=' + encodeURIComponent(json_string), function(json) {
    // });

}


